<i18n src="../../locales/lang.json"></i18n>

<template>
  <div  v-bind:class="{show : isvisible == true, displayblock : isvisible == true}" class="modal" tabindex="-1" v-bind:id="'modal' + getId()"  role="dialog">
    <div class="modal-dialog" v-bind:class="size">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button v-if="disableclose == 'false'" type="button" class="close"  @click="close()">&times;</button>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <button v-if="disableclose == 'false'" type="button" class="btn btn-link" @click="close()">{{$t('close')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  var savebuttonText = "not set";
  var disabled = false;


  export default {
    name: 'modal-in-front',
    components: {
    },
    props: {
      disableclose: {
        required: false,
        type: String,
        default: "false"
      },
      title: {
        required: false,
        type: String,
        default: null
      },
      onsave: {
        required: false,
        type: Function,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: null
      },
      size: {
        required: false,
        type: String,
        default: null
      },
      buttontext: {
        required: false,
        type: String,
        default: null
      }

    },
    data() {
      return {
        isvisible: this.show == "true",
        savebuttonText,
        disabled
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      open() {
        lightboxToFront('#modal' + this.getId())
        this.isvisible = true;
      },
      close() {
        lightboxToOrigin('#modal' + this.getId())
        this.isvisible = false;
      },
      doSave() {
        if (this.onsave != null) {
          this.onsave();
        }
      },
      disableButton() {
        this.disabled = true;
      },
      enableButton() {
        this.disabled = false;
      }
    },
    created() {

    },
    mounted() {
      if (this.buttontext != null) {
        this.savebuttonText = this.buttontext;
      }
      else 
        this.savebuttonText = this.$t('save');
    }
  }
</script>

<style scoped>
  .displayblock {
    display:block;
  }

  @media (max-width: 768px) {
    .modal {
      width: 100%;
      max-width: 100%;
      height: 100vh;
      margin: 0;
      min-height: 100vh;
    }

    .modal-dialog {
      margin: 0 !important;
      padding: 0px !important;
      height: 100%;
    }

    .modal-content {
      height: calc(100vh - 170px) !important;
      flex: none !important;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/modals/modal-in-front.vue